exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resumen-club-month-header{background-color:#000;color:#fff;text-align:center}.resumen-club-yellow{background-color:#fffade}.resumen-club-sticky-clave,.resumen-club-sticky-club{position:-webkit-sticky;position:sticky;background-color:#fff}.resumen-club-sticky-club{left:0;min-width:160px;width:160px}.resumen-club-sticky-clave{left:160px;min-width:100px;width:100px}thead .resumen-club-sticky-clave,thead .resumen-club-sticky-club{z-index:3}tbody .resumen-club-sticky-clave,tbody .resumen-club-sticky-club{z-index:1}", ""]);

// exports
